function initTalismanConfigurator() {
    const selectors = document.querySelectorAll('.talisman-selector');
    const totalPriceElement = document.getElementById('talisman-total-price');
    const submitButton = document.querySelector('.wpcf7-submit');

    // To avoid side effects on others pages
    if (selectors.length === 0) {
        return;
    }

    // Checking form validity
    const checkFormValidity = () => {
        // Check if the 3 steps are validated 
        const totalSelected = document.querySelectorAll('.talisman-card.is-selected').length;

        if (submitButton) {
            if (totalSelected === 3) {
                submitButton.disabled = false;
                submitButton.style.opacity = "1";
                submitButton.style.cursor = "pointer";
            } else {
                submitButton.disabled = true;
                submitButton.style.opacity = "0.5";
                submitButton.style.cursor = "not-allowed";
            }
        }
    };

    const updateTotalPrice = () => {
        let total = 0;
        let selectedTitles = [];

        const allSelectedCards = document.querySelectorAll('.talisman-card.is-selected');

        allSelectedCards.forEach(card => {
            const price = parseFloat(card.getAttribute('data-price')) || 0;
            const title = card.getAttribute('data-value');

            total += price;
            selectedTitles.push(title);
        });

        if (totalPriceElement) {
            totalPriceElement.innerText = total.toLocaleString('fr-FR') + ' €';
        }

        // Check form validity before 
        checkFormValidity();
    };

    // Disable submit button at initialisation 
    checkFormValidity();

    selectors.forEach(selector => {
        const cards = selector.querySelectorAll('.talisman-card');
        const targetId = selector.getAttribute('data-target');
        const hiddenInput = document.getElementById(targetId);

        cards.forEach(card => {
            card.addEventListener('click', function () {
                cards.forEach(c => c.classList.remove('is-selected'));
                this.classList.add('is-selected');

                if (hiddenInput) {
                    hiddenInput.value = this.getAttribute('data-value');
                }

                updateTotalPrice();
            });
        });
    });
}

// Redirect to thanks page
document.addEventListener('wpcf7mailsent', function (event) {
    window.location.href = 'thanks';
}, false);